// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SetupFee_ComprovantesEmAnaliseResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET /subscriptions/setup-fee/comprovantes-em-analise — a fila da conferência (Full). */
import type { SetupFee_ComprovanteRow } from './SetupFee_ComprovanteRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SetupFee_ComprovantesEmAnaliseResponseDados {
comprovantes: SetupFee_ComprovanteRow[]
total: number
}

export type SetupFee_ComprovantesEmAnaliseResponse = ApiResponse<SetupFee_ComprovantesEmAnaliseResponseDados>;

registerResponseContract('SetupFee_ComprovantesEmAnaliseResponse', {
  comprovantes: {
    type: 'array',
    required: true,
    items: {
      id:            { type: 'number',  required: true },
      franquia_id:   { type: 'number',  required: true },
      franquia_nome: { type: 'string',  required: false },
      situacao:      { type: 'string',  required: true },
      valor_cents:   { type: 'number',  required: true },
      moeda:         { type: 'string',  required: true },
      pago_em:       { type: 'string',  required: true },
      arquivo_nome:  { type: 'string',  required: false },
      enviado_por:   { type: 'string',  required: false },
      enviado_em:    { type: 'string',  required: true },
      revisado_por:  { type: 'string',  required: false },
      revisado_em:   { type: 'string',  required: false },
      motivo:        { type: 'string',  required: false },
    },
  },
  total:        { type: 'number',  required: true },
})
